import styled from '@mui/system/styled';
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Checkbox from '@mui/material/Checkbox'
import Button from '@mui/material/Button'
import Tab from "@mui/material/Tab";
import { Tabs } from "@mui/material";
export const CustomeCard = styled(Card)({
  width: "100%",
  height: "380px",
  position: 'relative',
  margin: 'auto',
  '@media (min-width:768px) and (max-width:912px)': {
    maxWidth: "230px",
    width: "230px",
    height: "330px",
    position: 'relative',
    margin: 'auto'

  },
  '@media (min-width:913px) ': {
    maxWidth: "230px",
    width: "230px",
    height: "380px",
    position: 'relative',
    margin: 'auto'
  }
})
export const CustomeCardMedia = styled(CardMedia)({
  width: "100% !important",

  height: "185px !important",
  // height: "120px!important" before,
  objectFit: " contain !important",
  "@media (min-width:280px) and (max-width:300px)": {
    height: "185px !important",

  },
  '@media (min-width:768px) and (max-width:912px)': {
    width: "100% !important",

    height: "200px !important",
    // height: "140px !important" before ,
    objectFit: " contain !important",
  },
  '@media (min-width:913px) ': {


    width: "100% !important",

    height: "210px !important",
    // height: "140px !important" before ,
    objectFit: " contain !important",
  }
})
export const CustomeCardActions = styled(CardActions)(({ locale }) => ({

  gap: "0rem",
  justifyContent: "space-between",
  padding: "0px ",
  flexDirection: "column",
  marginLeft: "0 !important",
  marginRight: "0 !important",

  alignItems: locale == "ar" ? "flex-start" : "flex-start",
  "&.MuiCardActions-root>:not(:first-of-type)": {
    marginLeft: "0 !important",
    marginRight: "0 !important",
    width: "100%",
  },
  '@media (min-width:768px) and (max-width:912px)': {

    gap: "2rem",
    justifyContent: "space-around",
    padding: "0px"
    ,
    "&.MuiCardActions-root>:not(:first-of-type)": {
      marginLeft: "0 !important",
      marginRight: "0 !important",
      width: "100%",
    }

    ,

  },
  '@media (min-width:913px) ': {

    gap: "0rem",
    justifyContent: "space-around",
    padding: "0px 0px 16px 0px",


  },
}))
export const CustomeCardContent = styled(CardContent)({
  padding: "10px 8px 0px 8px",
  '& .MuiTypography-root':
  {
    color: "black",
    fontSize: "0.8rem"
  },
  '@media (min-width:768px) and (max-width:912px)': {

    '& .MuiCardContent-root': {

      padding: "16px 16px 0px 16px"

    },
    '& .MuiTypography-root':
    {
      color: "black",
      fontSize: "0.8rem"
    },
  },
  '@media (min-width:913px) ': {
    padding: "10px 8px 0px 8px",
    '& .MuiTypography-root':
    {
      color: "black",
      fontSize: "0.9rem"
    },
  }


})
export const CustomeCheckbox = styled(Checkbox)({

  padding: " 16px 16px",




})
export const CustomeButton = styled(Button)({

  "&.MuiButton-root:hover": {
    backgroundColor: "transparent !important"
  },

  '& .MuiSvgIcon-root': {
    color: "#008C8D "
  },
  width: "100% ",
  borderRadius: "0% !important",


});
export const CustomeSuperTab = styled(Tabs)({
    '& .MuiTabs-flexContainer': {
        justifyContent: "initial",
        gap: "0rem"
    },
    '@media (min-width:768px) and (max-width:912px)': {
        '& .MuiTabs-flexContainer': {
            justifyContent: "initial",
            gap: "0.3rem"
        },
    },
    '@media (min-width:913px) ': {
        '& .MuiTabs-flexContainer': {
            justifyContent: "initial",
            gap: "0.5rem"
        },
    },
})
export const CustomeTab = styled(Tab)({
    height: "100%",
    '&.Mui-selected': {
        border: "0.5px solid #ccf0ef",
        color: "#008C8D  !important",
        fontWeight: 600,
        borderRadius: "12px ",
        opacity: "1 !important",
        backgroundColor: "white !important",

    },
    color: "black",
    opacity: 0.5,
    '@media (min-width:301px) and (max-width:767px)': {
        fontSize: "0.9rem ",
        width: "25% !important",
    },
    '@media (min-width:280px) and (max-width:300px)': {
        fontSize: "0.7rem ",
        width: "16% !important",
    }
    ,
    '@media (min-width:768px) and (max-width:912px)': {
        fontSize: "1rem",
        width: "19.299%  !important",
    },
    '@media (min-width:913px) ': {
        fontSize: "1.2rem",
        width: "19.299% !important",
        opacity: 0.5,
        height: "60px",
        padding: 5
    },

})